import { render, staticRenderFns } from "./craete.vue?vue&type=template&id=04343fbc&"
import script from "./craete.vue?vue&type=script&lang=js&"
export * from "./craete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports